export function removeFirstMatch<T>(
  arr: T[],
  matcher: (item: T) => boolean,
): T[] {
  const index = arr.findIndex(matcher);
  if (index === -1) return arr; // No match found, return the original array

  return [...arr.slice(0, index), ...arr.slice(index + 1)];
}
